<script lang="ts">
  import type { Snippet } from 'svelte';
  import Dialog from './Dialog.svelte';
  import Icon from './Icon.svelte';

  let {
    title,
    onClose,
    maxWidth = 420,
    role = 'dialog',
    children,
  }: {
    title: string;
    onClose: () => void;
    maxWidth?: number;
    role?: 'dialog' | 'alertdialog';
    children: Snippet;
  } = $props();
</script>

<Dialog {onClose}>
  <div
    class="modal"
    {role}
    aria-modal="true"
    aria-label={title}
    tabindex="-1"
    style:max-width="{maxWidth}px"
  >
    <header class="head">
      <h2>{title}</h2>
      <button class="close-btn" type="button" aria-label="Close" onclick={onClose}>
        <Icon name="x" size={18} />
      </button>
    </header>
    {@render children()}
  </div>
</Dialog>

<style>
  .modal {
    position: relative;
    background: var(--color-canvas);
    border-radius: var(--radius-md);
    padding: 1.5rem;
    width: 100%;
    box-shadow: rgba(15, 15, 15, 0.18) 0 24px 48px -8px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
  }
  .head h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--color-ink);
  }
  .close-btn {
    background: transparent;
    border: 0;
    width: 32px;
    height: 32px;
    border-radius: 9999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-muted);
    flex: none;
  }
  .close-btn:hover {
    background: var(--color-surface-soft);
    color: var(--color-ink);
  }
</style>
